// extracted by mini-css-extract-plugin
export default {"container":"HI-z","disabled":"II-z","bgBlack":"JI-z","content":"KI-z","countdown":"LI-z","topCaption":"MI-z","topHeading":"NI-z","heading":"OI-z","copy":"PI-z"};